import { AppContentType, FileType } from '@office-start/document-types';
export function getAppDetailsFromFileType(item, capabilities, isConsumer, wdOrigin, launchUrl, fileType) {
    var _a;
    var appDetails = undefined;
    if (!fileType) {
        return appDetails;
    }
    var fluidHostFile = capabilities.fluidSupportEnabled && fileType === FileType.Fluid;
    var wacHostApps = capabilities.wacHostApps;
    var wacHostFile = capabilities.wacHostApps &&
        !!wacHostApps &&
        fileType &&
        wacHostApps.has(fileType) &&
        !item.isLocalFile;
    if (fileType === FileType.ThirdParty) {
        var appId = item.app, id = item.id, extension = item.extension;
        appDetails = {
            type: AppContentType.MOS,
            fileType: fileType,
            appId: appId,
            entityId: extension,
            subPageId: id,
            launchAction: 'OpenMruItem',
            event: event,
        };
    }
    else if (fluidHostFile) {
        var driveId = item.driveId, docId = item.docId, canonicalUrl = item.canonicalUrl, sharepointIds = item.sharepointIds;
        appDetails = {
            type: AppContentType.Fluid,
            fileType: fileType,
            siteUrl: sharepointIds === null || sharepointIds === void 0 ? void 0 : sharepointIds.siteUrl,
            driveId: driveId !== null && driveId !== void 0 ? driveId : '',
            docId: docId !== null && docId !== void 0 ? docId : '',
            docUrl: canonicalUrl || '',
            launchAction: 'OpenMruItem',
            event: event,
        };
    }
    else if (fileType === FileType.Draft) {
        var driveId = item.driveId, docId = item.docId, canonicalUrl = item.canonicalUrl, sharepointIds = item.sharepointIds;
        appDetails = {
            type: AppContentType.Draft,
            siteUrl: sharepointIds === null || sharepointIds === void 0 ? void 0 : sharepointIds.siteUrl,
            driveId: driveId !== null && driveId !== void 0 ? driveId : '',
            docId: docId !== null && docId !== void 0 ? docId : '',
            docUrl: canonicalUrl || '',
            launchAction: 'OpenMruItem',
            fileType: fileType,
            event: event,
        };
    }
    else if (wacHostFile) {
        var driveId = item.driveId, docId = item.docId, app = item.app, isLocalFile = item.isLocalFile, isOnPremOrVanity = item.isOnPremOrVanity, canonicalUrl = item.canonicalUrl, fileName = item.fileName;
        appDetails = {
            appName: app,
            type: AppContentType.WAC,
            fileType: fileType,
            isLocalFile: isLocalFile,
            isOnPremOrVanity: isOnPremOrVanity,
            driveId: driveId,
            docId: docId,
            docUrl: canonicalUrl || '',
            fileName: fileName,
            event: event,
            isConsumer: isConsumer,
            wdOrigin: wdOrigin,
            launchUrl: launchUrl,
            launchAction: 'OpenMruItem',
            siteUrl: (_a = item.sharepointIds) === null || _a === void 0 ? void 0 : _a.siteUrl,
        };
    }
    return appDetails;
}
//# sourceMappingURL=getAppDetailsFromFileType.js.map